import React, { useState } from 'react';

import { Link, useNavigate } from 'react-router-dom';

import Swal from 'sweetalert2';

import { FaUsers } from 'react-icons/fa';

import Title from '../../Components/Admin/Title';
import { USER_CREATE_URL } from '../../utils/Constant';
import { authHeaders } from '../../utils/api';

function UserCreate() {

    const navigate = useNavigate();

    // =========================
    // FORM DATA
    // =========================

    const [formData, setFormData] = useState({
        name: '',
        mobile_no: '',
        email: '',
        type: '2',
        password: '',
        status: '1',
    });

    // =========================
    // ERROR STATE
    // =========================

    const [errors, setErrors] = useState({});

    // =========================
    // VALIDATION
    // =========================

    const validateErrors = (name, value, data = {}) => {

        let error = '';

        // required validation
        if (
            value === '' ||
            value === null ||
            value === undefined
        ) {

            if (
                name !== 'password' ||
                data.type == 1
            ) {

                error = 'This field is required';
            }
        }

        // mobile validation
        if (name === 'mobile_no' && value) {

            if (!/^\d+$/.test(value)) {

                error = 'Mobile number must contain only digits';
            }
            else if (value.length !== 10) {

                error = 'Mobile number must be exactly 10 digits';
            }
        }

        // email validation
        if (name === 'email' && value) {

            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {

                error = 'Invalid email';
            }
        }

        return error;
    };

    // =========================
    // HANDLE CHANGE
    // =========================

    const handleChange = (e) => {

        const { name, value } = e.target;

        const updatedData = {
            ...formData,
            [name]: value,
        };

        // remove password if user type selected
        if (name === 'type' && value == 2) {

            updatedData.password = '';
        }

        setFormData(updatedData);

        const error = validateErrors(
            name,
            value,
            updatedData
        );

        setErrors((prev) => ({
            ...prev,
            [name]: error,
        }));
    };

    // =========================
    // FORM VALIDATE
    // =========================

    const formValidate = () => {

        const tempErrors = {};

        Object.keys(formData).forEach((key) => {

            const error = validateErrors(
                key,
                formData[key],
                formData
            );

            if (error) {

                tempErrors[key] = error;
            }
        });

        setErrors(tempErrors);

        return Object.keys(tempErrors).length === 0;
    };

    // =========================
    // SUBMIT
    // =========================

    const handleSubmit = async (e) => {

        e.preventDefault();

        // validation
        const isValid = formValidate();

        if (!isValid) return;

        try {

            const res = await fetch(
                USER_CREATE_URL,
                {
                    method: "POST",
                    headers: authHeaders(),
                    body: JSON.stringify(formData),
                }
            );

            const data = await res.json();

            // validation error
            if (!res.ok) {

                if (data.errors) {

                    const formattedErrors = {};

                    Object.keys(data.errors).forEach((key) => {

                        formattedErrors[key] = data.errors[key][0];
                    });

                    setErrors(formattedErrors);
                }

                Swal.fire({
                    icon: 'error',
                    title: 'Oops!',
                    text: data.message || 'Something went wrong',
                });

                return;
            }

            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: data.message,
                timer: 2000,
                showConfirmButton: false,
            });

            setTimeout(() => {

                navigate('/admin/users');

            }, 2000);

        } catch (error) {

            console.log(error);

            Swal.fire({
                icon: 'error',
                title: 'Server Error',
                text: 'Something went wrong',
            });
        }
    };

    return (
        <>

            <Title
                icon={FaUsers}
                title='Create User'
            />

            <div className="bg-white rounded shadow-lg mt-5">

                <h4
                    className="
                        text-lg
                        p-4
                        font-semibold
                        border-b
                        flex
                        justify-between
                        items-center
                    "
                >

                    Create User

                    <Link
                        to="/admin/users"
                        className="
                            btn
                            btn-accent
                            btn-sm
                            text-white
                            shadow-md
                        "
                    >
                        Back
                    </Link>

                </h4>

                <form
                    onSubmit={handleSubmit}
                    className="p-4"
                >

                    <div className="grid grid-cols-2 gap-5">

                        {/* Name */}
                        <div>

                            <label className="block text-sm mb-1">
                                Name
                            </label>

                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className={`
                                    input
                                    input-bordered
                                    input-sm
                                    w-full
                                    ${errors.name ? 'border-error' : ''}
                                `}
                            />

                            {errors.name && (
                                <p className="text-red-500 text-xs mt-1">
                                    {errors.name}
                                </p>
                            )}

                        </div>

                        {/* Mobile */}
                        <div>

                            <label className="block text-sm mb-1">
                                Mobile No
                            </label>

                            <input
                                type="text"
                                name="mobile_no"
                                value={formData.mobile_no}
                                onChange={handleChange}
                                maxLength={10}
                                className={`
                                    input
                                    input-bordered
                                    input-sm
                                    w-full
                                    ${errors.mobile_no ? 'border-error' : ''}
                                `}
                            />

                            {errors.mobile_no && (
                                <p className="text-red-500 text-xs mt-1">
                                    {errors.mobile_no}
                                </p>
                            )}

                        </div>

                        {/* Email */}
                        <div>

                            <label className="block text-sm mb-1">
                                Email
                            </label>

                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className={`
                                    input
                                    input-bordered
                                    input-sm
                                    w-full
                                    ${errors.email ? 'border-error' : ''}
                                `}
                            />

                            {errors.email && (
                                <p className="text-red-500 text-xs mt-1">
                                    {errors.email}
                                </p>
                            )}

                        </div>

                        {/* Type */}
                        <div>

                            <label className="block text-sm mb-1">
                                Type
                            </label>

                            <select
                                name="type"
                                value={formData.type}
                                onChange={handleChange}
                                className={`
                                    select
                                    select-bordered
                                    select-sm
                                    w-full
                                    ${errors.type ? 'border-error' : ''}
                                `}
                            >

                                <option value="1">
                                    Admin
                                </option>

                                <option value="2">
                                    User
                                </option>

                            </select>

                            {errors.type && (
                                <p className="text-red-500 text-xs mt-1">
                                    {errors.type}
                                </p>
                            )}

                        </div>

                        {/* Password */}
                        {formData.type == 1 && (

                            <div>

                                <label className="block text-sm mb-1">
                                    Password
                                </label>

                                <input
                                    type="password"
                                    name="password"
                                    value={formData.password}
                                    onChange={handleChange}
                                    className={`
                                        input
                                        input-bordered
                                        input-sm
                                        w-full
                                        ${errors.password ? 'border-error' : ''}
                                    `}
                                />

                                {errors.password && (
                                    <p className="text-red-500 text-xs mt-1">
                                        {errors.password}
                                    </p>
                                )}

                            </div>
                        )}

                        {/* Status */}
                        <div>

                            <label className="block text-sm mb-1">
                                Status
                            </label>

                            <select
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                className={`
                                    select
                                    select-bordered
                                    select-sm
                                    w-full
                                    ${errors.status ? 'border-error' : ''}
                                `}
                            >

                                <option value="1">
                                    Active
                                </option>

                                <option value="0">
                                    Inactive
                                </option>

                            </select>

                            {errors.status && (
                                <p className="text-red-500 text-xs mt-1">
                                    {errors.status}
                                </p>
                            )}

                        </div>

                    </div>

                    {/* Button */}
                    <div className="mt-5">

                        <button
                            type="submit"
                            className="
                                btn
                                btn-primary
                                btm-sm
                                text-white
                            "
                        >
                            Create User
                        </button>

                    </div>

                </form>

            </div>

        </>
    );
}

export default UserCreate;